module.exports = __webpack_public_path__ + "media/images/lb/872-42a9d2dffaa13da0fbbbcc03300b3c17.svg";